/**
 * TDT-3234 (47958): taksit tarihine ay ekler, ay taşması olmadan. `Date.setMonth`
 * 29.01 + 1 ayı 01.03'e taşıyordu; burada kısa ayda ayın son günü alınır
 * (29.01 → 28.02, 31.10 → 30.11). API'deki taksit tarihleriyle aynı kural
 * (TaksitHesaplayici::sonrakiTaksitTarihiniGetir, Carbon addMonthsNoOverflow).
 *
 * Tarihler "YYYY-MM-DD" metninden `new Date(...)` ile (UTC gece yarısı) kurulup
 * `toISOString().slice(0, 10)` ile geri yazıldığından hesap UTC üzerinden yapılır.
 */
export function ayEkleTasmasiz(tarih: Date, ay: number): Date {
    const yil = tarih.getUTCFullYear();
    const hedefAy = tarih.getUTCMonth() + ay;
    const ayinSonGunu = new Date(Date.UTC(yil, hedefAy + 1, 0)).getUTCDate();
    const sonuc = new Date(tarih.getTime());
    sonuc.setUTCFullYear(yil, hedefAy, Math.min(tarih.getUTCDate(), ayinSonGunu));
    return sonuc;
}
